import ServiceCRUD from 'services/ServiceImageUpload';

class ImageServiceUpload extends ServiceCRUD {
  constructor() {
    super(`/img/upload/fotoperfil`);
  }
}

export default new ImageServiceUpload();
